import React from 'react';
import { Form, Input, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { normalizeCrawlerPhone } from '../../../domain/entities/Crawler';

interface AddCrawlerModalProps {
  open: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onSubmit: (phone: string) => Promise<void>;
}

interface AddCrawlerFormValues {
  phone: string;
}

const AddCrawlerModal: React.FC<AddCrawlerModalProps> = ({ open, isSaving, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<AddCrawlerFormValues>();

  const validatePhone = async (_: unknown, value: string) => {
    try {
      normalizeCrawlerPhone(value);
    } catch {
      throw new Error(t('crawler-phone-invalid', { ns: 'errors' }));
    }
  };

  return (
    <Modal
      open={open}
      title={t('crawler-add', { ns: 'titles' })}
      okText={t('crawler-add-and-request-code', { ns: 'buttons' })}
      cancelText={t('cancel', { ns: 'buttons' })}
      confirmLoading={isSaving}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary">{t('crawler-add-hint', { ns: 'standard' })}</Typography.Paragraph>
      <Form form={form} layout="vertical" preserve={false} requiredMark={false} onFinish={(values) => onSubmit(values.phone)}>
        <Form.Item name="phone" label={t('phone', { ns: 'labels' })} rules={[{ validator: validatePhone }]}>
          <Input placeholder="+7 999 123-45-67" autoFocus inputMode="tel" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCrawlerModal;
